import { List, ListItem, Typography } from "@mui/material";
import { LoginStyles } from "../../../customStyles";
import { passwordRequirements } from ".";

export const ListOfPWRequirements = () => {
  return (
    <List sx={LoginStyles.pwRequirementStyle}>
      {passwordRequirements.map((list) => (
        <ListItem sx={{ display: 'list-item', padding: 0 }} key={list}>
          <Typography variant='body2' color='text.secondary' >
            {list}
          </Typography>
        </ListItem>
      ))}
    </List>
  )
}